import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'

import applyMask from 'component/report/utils/Formatter'
import { formatDecimalDynamic } from 'utils/masks'
import columns from './columns'
import resize from 'images/h-resize.svg'
import ResizableDiv from 'component/ResizableDiv'

class Table extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    handleResize: PropTypes.func.isRequired,
    records: PropTypes.array.isRequired,
    sideFilterElement: PropTypes.object,
    sideFilterVisible: PropTypes.bool.isRequired,
    topMargin: PropTypes.number.isRequired,
    translate: PropTypes.func.isRequired,
  }

  componentDidUpdate() {
    this.handleLeft()
  }

  handleLeft = () => {
    const { records, sideFilterElement, sideFilterVisible } = this.props

    const columnsToRender = columns.filter(
      (column) => column.fixed && column.render
    )

    columnsToRender.forEach((column, index) => {
      const node = ReactDOM.findDOMNode(this.refs[column.field])

      const lastNode =
        index === 0
          ? node
          : ReactDOM.findDOMNode(this.refs[columnsToRender[index - 1].field])

      const left =
        index === 0
          ? `${sideFilterVisible ? sideFilterElement.clientWidth : 0}px`
          : `${
              lastNode.clientWidth +
              Number(lastNode.style.left.replace('px', ''))
            }px`

      node.style.left = left

      for (let i = 0; i < records.length; i++) {
        ReactDOM.findDOMNode(this.refs[`${column.field}${i}`]).style.left = left
      }
    })

    columns
      .filter((column) => !column.fixed && column.render)
      .map((column) => {
        const left = 'auto'

        ReactDOM.findDOMNode(this.refs[column.field]).style.left = left

        for (let i = 0; i < records.length; i++) {
          ReactDOM.findDOMNode(this.refs[`${column.field}${i}`]).style.left =
            left
        }
      })
  }

  renderHeader = () => {
    const { topMargin, translate } = this.props

    const renderColumns = columns

    return renderColumns.reduce((acc, column) => {
      if (column.render) {
        return [
          ...acc,
          <th
            className={column.fixed ? 'sticky-column' : 'scroll-column'}
            key={`${column.headerLabel}.${column.field}`}
            ref={column.field}
            style={{ top: `${topMargin}px` }}
          >
            <ResizableDiv
              axis='x'
              className={`cell ${column.className}`}
              handle={
                <div className='resize-handle'>
                  <img src={resize} />
                </div>
              }
              height={45}
              key={column.field}
              onResizeStop={this.handleLeft}
              width={200}
            >
              <div className='header'>{translate(column.headerLabel)}</div>
            </ResizableDiv>
          </th>,
        ]
      }

      return [...acc]
    }, [])
  }

  renderFieldValue = (type, field, translate, headerLabel, numHouses) => {
    if (type === 'decimal2' && (field || field === 0)) {
      return formatDecimalDynamic(field, numHouses, translate)
    }
    if (type === 'currency-null' && field === 0) {
      return '-'
    }
    return applyMask(type, field, translate, headerLabel)
  }

  renderBody = () => {
    const { handleResize, records, translate } = this.props

    handleResize()

    const renderColumns = columns

    return records.map((row, i) => (
      <tr key={i}>
        {renderColumns.reduce((acc, column) => {
          if (column.render) {
            return [
              ...acc,
              <td
                className={column.fixed ? 'sticky-column' : 'scroll-column'}
                key={column.field}
                ref={`${column.field}${i}`}
              >
                <div className={column.className}>
                  {this.renderFieldValue(
                    column.type,
                    row[column.field],
                    translate,
                    column.headerLabel,
                    row.numHouses
                  )}
                </div>
              </td>,
            ]
          }

          return [...acc]
        }, [])}
      </tr>
    ))
  }

  render() {
    return (
      <table className='table-adjustment'>
        <thead>
          <tr>{this.renderHeader()}</tr>
        </thead>
        <tbody>{this.renderBody()}</tbody>
      </table>
    )
  }
}

export default Table
